
namespace Gamification.Gamification {
    export class UtentiProdottiColumns {
        static columnsKey = 'Gamification.UtentiProdotti';
    }
}